import React, { useState } from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import InstagramTab from './InstagramTab';
import WordPressTab from './WordPressTab';

const PublishPostModal = ({
  isOpen,
  onClose,
  selectedArticleId,
  selectedArticleTitle,
  selectedArticleSummary,
  selectedArticleLLMSummary
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80vw',
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          display: 'flex'
        }}
      >
        {/* Vertical Tabs */}
        <Tabs
          orientation="vertical"
          value={activeTab}
          onChange={handleChange}
          sx={{ borderRight: 1, borderColor: 'divider', minWidth: 120 }}
        >
          <Tab label="WordPress" />
          <Tab label="Instagram" />
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ flex: 1, pl: 4 }}>
          {activeTab === 0 && (
            <WordPressTab
              selectedArticleId={selectedArticleId}
              selectedArticleTitle={selectedArticleTitle}
              selectedArticleSummary={selectedArticleSummary}
              selectedArticleLLMSummary={selectedArticleLLMSummary}
            />
          )}
          {activeTab === 1 && (
            <InstagramTab
              selectedArticleId={selectedArticleId}
              selectedArticleTitle={selectedArticleTitle}
              selectedArticleSummary={selectedArticleSummary}
              selectedArticleLLMSummary={selectedArticleLLMSummary}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default PublishPostModal;